import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class CashNoteService extends DatabaseGwService{
  URL_PATH:string = '/cash-notes';
}
